interface HomePageLoadingStateOptions {
    redirectLoading: boolean;
    isAuthCallbackLoading: boolean;
}

export function shouldShowHomePageLoading({
    redirectLoading,
    isAuthCallbackLoading,
}: HomePageLoadingStateOptions): boolean {
    return redirectLoading || isAuthCallbackLoading;
}
